import { UnionNoticeBoard } from '../shared/UnionNoticeBoard.jsx';

export function DesktopUnionNotices({ onNavigate }) {
  return <UnionNoticeBoard onNavigate={onNavigate} />;
}
